import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CONST_AWS_API } from 'src/app/core/constants';
import { environment } from 'src/environments/environment';
import { ContactDialogComponent } from '../contact-dialog/contact-dialog.component';
import { CommanSubscribeService } from './../../../../../../core/services/comman-subscribe.service';
import { Subscription } from 'rxjs';
import * as moment from "moment";
import { DomSanitizer } from '@angular/platform-browser';
import { API as AWS_API } from 'aws-amplify';
import { UserService } from 'src/app/core/services/user.service';
declare let $: any;
@Component({
  selector: 'app-expo-details',
  templateUrl: './expo-details.component.html',
  styleUrls: ['./expo-details.component.scss']
})
export class ExpoDetailsComponent implements OnInit {
  userInfo: any;
  expoInfo: any;
  rooms: any;
  expoInterval: ReturnType<typeof setInterval> | undefined; //NodeJS.Timer;;
  expo_id: any;
  slugInfoSubscr: Subscription;
  adInfo: any;
  userInfoSubscription: Subscription;
  ip:any = null;
  streamAdsData: any;
  sponsorData: any;
  preloadAdsdata: any[];
  adVideo: any;
  allAds: any;
  eventHomeAdsTop: any[];
  eventHomeAdsRight: any[];
  streamAdsDataRight: any[];
  streamAdsDataTop: any[];
  streamAds: any;
  streamInfoData: any;
  streamInfo: any = {};
  timezoneVal:any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private commanSubscribeService: CommanSubscribeService,
    private ngxLoader: NgxUiLoaderService,
    private _matDialog: MatDialog,
    private sanitizer: DomSanitizer,
    private matDialogRef: MatDialogRef<ExpoDetailsComponent>,
    private userService:UserService
  ) { }

  ngOnInit() {
    this.timezoneVal = this.userService.getTimezone();
    this.commanSubscribeService.sendScreenStatus(false);
    this.userInfo = this.commanSubscribeService.userInfo;
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.slugInfoSubscr = this.commanSubscribeService.getSlugData().subscribe(response => {
      this.adInfo = response;
      this.eventDetails(this.adInfo);
    });
    this.getUserInfo();
    this.getLiveEventById();
    console.log(this.userInfo, "userInfo");
    this.expo_id = this.route.snapshot.params.id;
    this.getExpoDetails(this.expo_id);
    this.expoInterval = setInterval(() => {
      this.getExpoDetails(this.expo_id);
    }, 4 * 5000);
  }

  isYoutubeVideo: boolean = false;
  getExpoDetails(expo_id) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_EXPO_BY_ID + '/' + expo_id;
    API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        // console.log("response", response);
        this.expoInfo = response.data.Data;
        this.commanSubscribeService.sendExpoDetailsToHeader(this.expoInfo);
        this.rooms = response.data.Data.rooms;
        if (this.expoInfo.video) {
          if (this.expoInfo.video.includes('https://www.youtube.com')) {
            this.expoInfo.video = this.expoInfo.video.replace('watch?v=', 'embed/');
            this.isYoutubeVideo = true;
          } else {
            this.isYoutubeVideo = false;
          }
        }
        this.rooms.forEach(element => {
          element.expo_timings = typeof (element.expo_timings) == 'string' ? JSON.parse(element.expo_timings) : element.expo_timings
          element.expo_timings.forEach(e => {
            let localTime =  moment.tz(e.start_date_time, element.timezones).tz(this.timezoneVal);
            e.start_date_time_final = localTime.format('DD MMM YYYY, hh:mm A');
            // let localTime = moment.utc(e.start_date_time).toDate();
            // element.start_date_time = moment(localTime).format('DD MMM YYYY, hh:mm A');
            // e.start_date_time_final = moment(localTime).format('DD MMM YYYY, hh:mm A');
            let localEndTime =  moment.tz(e.end_date_time, element.timezones).tz(this.timezoneVal);
            e.end_date_time_final = localEndTime.format('DD MMM YYYY, hh:mm A');
            // let localEndTime = moment.utc(e.end_date_time).toDate();
            // element.end_date_time = moment(localEndTime).format('hh:mm A');
            // e.end_date_time_final = moment(localEndTime).format('hh:mm A');
          });
        });
        console.log("all", this.expoInfo, "rooms", this.rooms);
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });

  }
  joinRoom(token, expo_id, room_id) {
    let contactInfo = {
      first_name: this.userInfo.user_first_name,
      last_name: this.userInfo.user_last_name,
      email: this.userInfo.email,
      phone_number: this.userInfo.user_phone_number,
      org_name: "",
    }
    let params = {
      startTime: new Date(),
      contact_details: contactInfo,
      is_session: 1,
      user_id: this.userInfo.id,
      expo_room_id: room_id,
      expo_id: this.expoInfo.id,
      event_id: this.expoInfo.event_id,
    }
    console.log("params", params);
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: params
    }
    let url = CONST_AWS_API.START_VIDEO_ROOM_SESSION;
    API.post(environment.AWS_Cognito.apiName, url, data).then(response => {
      // console.log("response", response);
      if (response.data.statusCode === '200') {
        let session_id = response.data.Data;
        this.router.navigate([`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/expo-room`, token, expo_id, session_id, this.route.snapshot.params.ticket_key]);
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }
  contact(room_id) {
    let data = {
      expoInfo: this.expoInfo,
      roomInfo: this.rooms.filter(e => e.id = room_id)[0]
    }
    // this.matDialogRef.close("");
    const dialogRef = this._matDialog.open(ContactDialogComponent, {
      maxWidth: "450px",
      panelClass: "app-contact-dialog",
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "yes") {
        this.matDialogRef.close("");
      }
    });
  }

  getUserInfo() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let splits = this.route.snapshot.params.ticket_key.split("-");
    let url = CONST_AWS_API.GET_CONTACT_DETAILS + '/' + splits[1];
    API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        let userInfo = response['data']['Data'];
        userInfo.signedIn = true;
        userInfo.is_profile_completed = true;
        userInfo.access_token = this.userInfo.access_token;
        this.commanSubscribeService.sendUserInfo(userInfo);
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }

  goBack() {
    this.router.navigateByUrl(`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/expo-list/` + this.route.snapshot.params.ticket_key);
  }

  getLiveEventById() {
    let splits = this.route.snapshot.params.ticket_key.split("-");
    let ids = {
      "stream_id": splits[0],
      "userid": splits[1],
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: ids
    }
    this.ngxLoader.start();
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_LIVE_EVENT_BY_ID, data).then(response => {
      this.ngxLoader.stop();
      this.commanSubscribeService.sendSlugData(response['data']['Data']);
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }
  loadAdsScript() {
    document.querySelectorAll('.videoAds').forEach(vid => (<HTMLVideoElement>vid).pause());
    $('.carousel-inner img').attr('alt', '');
    $('.carousel-inner img').attr('title', '');
    var t;
    var start = $('#myCarousel').find('.active').attr('id');
    t = setTimeout("$('#myCarousel').carousel({interval: 1000});", start - 1000);
    $('#myCarousel').on('slid.bs.carousel', function (ev) {
      clearTimeout(t);
      var duration1 = $(this).find('.active').attr('id');
      console.log(duration1);
      let slides = $(this).find('.carousel-item');
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if (pvid && (pvid != undefined || pvid != 'undefined')) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if (vid && (vid != undefined || vid != 'undefined')) {
        // vid.muted = true;
        (<HTMLVideoElement>vid).play();
      }
      $('#myCarousel').carousel('pause');
      t = setTimeout("$('#myCarousel').carousel();", duration1 - 1000);
    })
    $('.carousel-control-next').on('click', () => {
      clearTimeout(t);
    });
    $('.carousel-control-prev').on('click', () => {
      clearTimeout(t);
    });
    var r;
    var start = $('#RightCarousel').find('.active').attr('id');
    r = setTimeout("$('#RightCarousel').carousel({interval: 1000});", start - 1000);
    $('#RightCarousel').on('slid.bs.carousel', function (ev) {
      clearTimeout(r);
      var duration2 = $(this).find('.active').attr('id');
      console.log(duration2);
      let slides = $(this).find('.carousel-item');
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if (pvid && (pvid != undefined || pvid != 'undefined')) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if (vid && (vid != undefined || vid != 'undefined')) {
        // vid.muted = true;
        (<HTMLVideoElement>vid).play();
      }
      $('#RightCarousel').carousel('pause');
      r = setTimeout("$('#RightCarousel').carousel();", duration2 - 1000);
    })
    $('.carousel-control-next').on('click', () => {
      clearTimeout(r);
    });
    $('.carousel-control-prev').on('click', () => {
      clearTimeout(r);
    });
  }

  eventDetails(adInfo) {
    this.streamAds = adInfo['stream_info']['stream_ads'];
    console.log('All ads from dynamo', this.streamAds);
    this.streamAdsData = [];
    if (this.streamAds && this.streamAds.length > 0) {
      this.streamAds.forEach(element => {
        if (element.ad_size && element.ad_size == "728x90" || element.ad_size == "300x600") {
          this.streamAdsData.push(element);
        }
      });
      console.log('Schedule page ads from dynamo', this.streamAdsData);
      if (this.streamAdsData.length > 0) {
        this.getAds();
      }
    }

  }
  selectedAdData: any;
  async getAds() {
    let allDiv = [];
    let count = 0;

    var temp_site_id = null;
    this.preloadAdsdata = [];
    if (this.streamAdsData && this.streamAdsData.length > 0) {
      this.sponsorData = this.streamAdsData;
      var j = 0;
      var i = 1;

      var adTypeIdarr = [];
      var placements = [];
      this.streamAdsData.forEach(el => {
        temp_site_id = Number(el.site_id)
        j += 1;
        adTypeIdarr.push(el.adTypeId);
        placements.push({
          "divName": "div" + i + j,
          "networkId": Number(environment.kevel.NETWORK_ID),
          "siteId": Number(el.site_id),
          "adTypes": [el.adTypeId],
          "campaignId": Number(el.campaignId),
          "flightId": Number(el.flight_id),
          "adId": Number(el.ad_id)
        });
        allDiv.push("div" + i + j);
        count = count + 1;
        if (this.streamAdsData.length == count) {
          let data = {
            "placements": placements,
            "allDiv": allDiv
          };
          if (temp_site_id) {
            this.eventHomeAdsTop = [];
            this.eventHomeAdsRight = [];
            this.commanSubscribeService.getAdsData(data, (err, result) => {
              this.preloadAdsdata = result.Ads_data;
              console.log("Schedule page Ads :::: ", this.preloadAdsdata);
              if (this.preloadAdsdata.length > 0) {
                this.preloadAdsdata.forEach(element => {
                  this.selectedAdData = element.clickUrl;
                  console.log('eventHomeAdsRight selectedAdData :: ', this.selectedAdData);
                  if (element.contents && element.contents[0] && element.contents[0].body && element.width == 728 && element.height == 90) {
                    let adType = element.contents[0];
                    let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    let duration = adType['data']['customData']['maxPlayTime'];
                    this.adVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
                    this.eventHomeAdsTop.push({ 'image': this.adVideo, 'duration': (duration * 1000) });
                    if (element.impressionUrl) {
                      this.commanSubscribeService.countAdsImpressions(element.impressionUrl);
                    }
                  }
                  if (element.contents && element.contents[0] && element.contents[0].body && element.width == 300 && element.height == 600) {
                    let adType = element.contents[0];
                    // let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    let duration = adType['data']['customData']['maxPlayTime'];
                    let rightsadVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
                    this.eventHomeAdsRight.push({ 'image': rightsadVideo, 'duration': (duration * 1000) });
                    if (element.impressionUrl) {
                      this.commanSubscribeService.countAdsImpressions(element.impressionUrl);
                    }
                  }
                });
                console.log('scheduleAdsTop :: ', this.eventHomeAdsTop);
                console.log('scheduleAdsRight :: ', this.eventHomeAdsRight);
                setTimeout(() => {
                  this.loadAdsScript();
                }, 200);
              }
            });
          }
        }
      });
    }
  }
  ngOnDestroy() {
    if (this.expoInterval) {
      clearInterval(this.expoInterval);
    }
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
  }
}
